import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { PendoEffects } from './pendo.effects';

@NgModule({
  declarations: [],
  imports: [CommonModule, EffectsModule.forFeature([PendoEffects])],
})
export class PendoStoreModule {}
